import { request } from 'umi';

export async function validationAddress(address: any) {
  const data = new FormData();
  data.append('answers', JSON.stringify(address));
  return request<API.Address>('/api/location/validateAddress', {
    method: 'POST',
    data,
  });
}
export async function isExistZipcode(zipCode: string) {
  return request(`/api/site-setting/${zipCode}`, {
    method: 'GET',

  });
}
